// frontend/src/components/About/AboutArtStudio.js
// Enhanced version with scroll-to-anchor on mount

import React, { useEffect } from "react";
import "./AboutArtStudio.css";

const AboutArtStudio = () => {
  // Handle scroll to anchor on component mount
  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Small delay to ensure the DOM is fully rendered
      setTimeout(() => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="about-main">
      <div className="about-content">
        {/* Hero Image Section */}
        <div className="about-hero">
          <img
            src="/images/Studiophoto4.png"
            alt="Yuliart Studio"
            className="about-hero-image"
          />
          <div className="about-hero-overlay">
            <h1 className="about-hero-title">About Yuliart Studio</h1>
          </div>
        </div>

        {/* Content Section */}
        <div className="about-text-section">
          <div className="about-intro">
            <h2 className="about-section-title">The Artist</h2>
            <div className="about-artist-content">
              <div className="about-artist-image-container">
                <img
                  src="/images/yulik.png"
                  alt="Yulia Jeltuhin"
                  className="about-artist-image"
                />
              </div>
              <div className="about-artist-text">
                <p className="about-paragraph about-lead">
                  Hello, I am Yulia Jeltuhin, a working artist with a passion
                  for oil painting, sculpture, and paper collages. I have been
                  painting for over 20 years and teaching art for 15. My works
                  have been on display in Europe and the United States, and many
                  have joined private collections in England, Israel, Sweden,
                  Germany, Russia, Canada, and the US. All works in the online
                  gallery are available for purchase. If you would like to
                  acquire any of them, please email me at
                  yulia.jeltuhin@gmail.com.
                </p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">Art Classes</h2>
            <p className="about-paragraph">
              The studio has been open to children and youth since 2003. My
              students start as early as age 4, and many stay with me through
              high school graduation. I offer both private and group lessons,
              and in both formats we have a lot of fun while learning a great
              deal from each other. The virtual gallery demonstrates our
              progress and accomplishments. Browse the works on display and
              marvel at the results of our hard work. Please don't hesitate to
              call me at +1 (404) 271-8259 if you have questions or would like
              to set up an appointment.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">Art Education</h2>
            <p className="about-paragraph">
              To be an interesting person means being able to express yourself
              in an original and compelling way. Painting is one of the key
              means of expression. Like eloquence, the ability to draw is both a
              gift and a skill. Anyone can learn, and anyone can develop this
              skill. The end result will vary depending on natural talent and
              how diligently the skill is developed and maintained—like anything
              else worth pursuing. One thing to remember: drawing is not just
              about the result. It is about the process of exploring the self
              and the world around us. It is about telling a story in an
              interesting, creative, and unpredictable way. This process can at
              times be laborious, but it is always rewarding and fun, both for
              the artist and those around them. The studio accepts students as
              young as age 4. In the beginning, we learn to paint still life:
              neatly arranged fruits, pieces of china, and later figurines. We
              start with acrylic—it dries quickly and is easy to work with. As
              students' skills mature, we explore other genres and media.
              Landscapes are typically the next step, followed by portraits for
              more advanced students. Everyone gets to try pencil drawing and
              watercolor, which some students adopt as their preferred medium.
              Oil painting is the most challenging, but we venture there as
              well. Recently, we added clay sculpture and papier-mâché to the
              curriculum. These media have become very popular with students.
            </p>
          </div>

          {/* Contact Info Box - Added anchor */}
          <div id="contact" className="about-contact-box">
            <h3 className="about-contact-title">Get in Touch</h3>
            <p className="about-contact-detail">
              <strong>Text:</strong> +1 (404) 271-8259
            </p>
            <p className="about-contact-detail">
              <strong>Hours:</strong> Tuesday - Sunday, 10:00 AM - 6:00 PM
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutArtStudio;
